import { apiV2 } from "../v2";
import {
  deleteAdminArticleResponse,
  getAdminArticleRequest,
  getAdminArticleResponse,
  listAdminArticlesRequest,
  listAdminArticlesResponse,
  publishAdminArticlesRequest,
  publishAdminArticlesResponse,
  setAdminArticleStatusRequest,
  updateAdminArticleRequest,
} from "./articles.dto";
import { getAdminAuthorStatsResponse } from "./authors.dto";

export const listAdminArticlesApi = apiV2("GET", "/admin/articles").withRequest(listAdminArticlesRequest).withResponse(listAdminArticlesResponse);

/** Publishes the given `pending_publish` articles now, as the hourly job would, one after the other. */
export const publishAdminArticlesApi = apiV2("POST", "/admin/articles/publish")
  .withRequest(publishAdminArticlesRequest)
  .withResponse(publishAdminArticlesResponse);

export const getAdminArticleApi = apiV2("GET", "/admin/articles/:alias/:articleId").withRequest(getAdminArticleRequest).withResponse(getAdminArticleResponse);

export const getAdminArticleStatsSummaryApi = apiV2("GET", "/admin/articles/:alias/:articleId/stats")
  .withRequest(getAdminArticleRequest)
  .withResponse(getAdminAuthorStatsResponse);

export const updateAdminArticleApi = apiV2("PUT", "/admin/articles/:alias/:articleId")
  .withRequest(updateAdminArticleRequest)
  .withResponse(getAdminArticleResponse);

export const setAdminArticleStatusApi = apiV2("POST", "/admin/articles/:alias/:articleId/status")
  .withRequest(setAdminArticleStatusRequest)
  .withResponse(getAdminArticleResponse);

export const deleteAdminArticleApi = apiV2("DELETE", "/admin/articles/:alias/:articleId")
  .withRequest(getAdminArticleRequest)
  .withResponse(deleteAdminArticleResponse);
